import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=c633c45a&scoped=true"
import script from "./AvatarSelector.vue?vue&type=script&lang=js"
export * from "./AvatarSelector.vue?vue&type=script&lang=js"
import style0 from "./AvatarSelector.vue?vue&type=style&index=0&id=c633c45a&prod&lang=scss"
import style1 from "./AvatarSelector.vue?vue&type=style&index=1&id=c633c45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c633c45a",
  null
  
)

export default component.exports